(() => {
  'use strict';
  if (window.donglinInquiryEventsInitialized) return;
  window.donglinInquiryEventsInitialized = true;
  const storageKey = 'donglin_quote_context';
  const maxContextAge = 30 * 60 * 1000;
  const emit = (name, detail) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...detail });
    window.dispatchEvent(new CustomEvent('donglin:' + name, { detail }));
  };
  const localContact = link => {
    try {
      const url = new URL(link.href, location.origin);
      return url.origin === location.origin && /\/pages\/contact\/?$/.test(url.pathname) ? url : null;
    } catch { return null; }
  };
  const cleanSource = value => {
    if (!value) return '';
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || /\/pages\/contact\/?$/.test(url.pathname)) return '';
      if (/\/(?:account|cart|checkout|checkouts|admin)(?:\/|$)/.test(url.pathname)) return '';
      return url.origin + url.pathname;
    } catch { return ''; }
  };
  const cleanHandle = value => /^[a-z0-9][a-z0-9-]*$/.test(value || '') ? value : '';
  const recordClick = event => {
    if (event.defaultPrevented || (event.type === 'auxclick' ? event.button !== 1 : event.button !== 0)) return;
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    const link = target?.closest('a[href]');
    if (!link || link.hasAttribute('download') || link.getAttribute('aria-disabled') === 'true') return;
    const url = localContact(link);
    if (!url || /\/pages\/contact\/?$/.test(location.pathname)) return;
    const intent = link.getAttribute('data-donglin-inquiry-intent');
    if (intent === 'ignore' || intent === 'contact') return;
    const productCard = link.closest('product-card');
    const buttonCTA = link.matches('.button, .button-secondary, .button-unstyled, .button-custom');
    const navigation = link.closest('header, footer, nav, [role="navigation"], .shopify-section-group-header-group, .shopify-section-group-footer-group');
    if (navigation && !productCard && !buttonCTA && intent !== 'quote' && intent !== 'catalog' && intent !== 'sample') return;
    const handle = cleanHandle(url.searchParams.get('product'));
    const context = {
      enquiry_source: cleanSource(location.href),
      product_handle: handle,
      storefront_locale: document.documentElement.lang,
      enquiry_intent: intent === 'catalog' || intent === 'sample' ? intent : 'quote',
      enquiry_placement: productCard ? 'product_card' : navigation ? 'navigation_cta' : 'content'
    };
    try { sessionStorage.setItem(storageKey, JSON.stringify({ ...context, captured_at: Date.now() })); } catch {}
    emit('request_quote_click', context);
  };
  document.addEventListener('click', recordClick);
  document.addEventListener('auxclick', recordClick);
  const success = () => {
    document.querySelectorAll('main form').forEach(form => {
      if (!form.querySelector('textarea[name="contact[body]"]') || !form.querySelector('.contact-form__success') || form.dataset.donglinSuccessTracked) return;
      form.dataset.donglinSuccessTracked = 'true';
      let context = {};
      try {
        const stored = JSON.parse(sessionStorage.getItem(storageKey) || '{}');
        const age = Date.now() - stored.captured_at;
        if (Number.isFinite(age) && age >= 0 && age <= maxContextAge) {
          context = {
            enquiry_source: cleanSource(stored.enquiry_source),
            product_handle: cleanHandle(stored.product_handle),
            enquiry_intent: ['quote', 'catalog', 'sample'].includes(stored.enquiry_intent) ? stored.enquiry_intent : 'quote',
            enquiry_placement: stored.enquiry_placement || 'content'
          };
        }
        sessionStorage.removeItem(storageKey);
      } catch {}
      const parameters = new URLSearchParams(location.search);
      if (!context.enquiry_source) context.enquiry_source = cleanSource(parameters.get('source'));
      if (!context.product_handle) context.product_handle = cleanHandle(parameters.get('product'));
      emit('quote_form_submit_success', { ...context, storefront_locale: document.documentElement.lang });
    });
  };
  const ready = () => {
    success();
    if (document.body) new MutationObserver(success).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
})();
